import { useSelector } from "react-redux";

const CollectionListItem = ({ data, index, customization }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  return (
    <div style={{
      paddingLeft: index !== 0 ? 10 : 0,
    }}
    >
      {data.map((item, idx) => (
        <div key={idx} style={{
          borderBottom: index === 0 ? "1px solid" : "",
          borderColor: customization?.borderColor || "black"
        }}>
          <div

            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: customization?.gap,
              paddingBottom: customization?.gap,

            }}
          >
            {item.icon ? (
              <div>
                <img src={item.icon} width={staticValues[20]} height={staticValues[20]} />
              </div>
            ) : (
              <div ></div>
            )}
            <div style={{
              textAlign: 'start', flex: 1,
              fontSize: index === 0 ? customization?.textSize : customization?.childTextSize,
              fontWeight: index === 0 ? customization?.textWeight : customization?.childTextWeight,
              color: index === 0 ? customization?.textColor : customization?.childTextColor,
            }}>{item.title}</div>
            <div style={{ paddingRight: staticValues[10] }}>{item?.children?.length > 0 && <>{idx === 0 ? <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="48" fill="white" fill-opacity="0.01" />
              <path d="M37 18L25 30L13 18" style={{ stroke: index === 0 ? customization?.textColor : customization?.childTextColor }} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            </svg> : <svg width="24px" height="24px" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="48" height="48" fill-opacity="0.01" />
              <path d="M19 12L31 24L19 36" style={{ stroke: index === 0 ? customization?.textColor : customization?.childTextColor }} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>}</>}</div>
          </div>

          {idx === 0 && <CollectionListItem data={item.children} index={idx + 1} customization={customization} />}
        </div>
      ))}
    </div>
  );
};

export default CollectionListItem;
